export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9549.b37b9463.jpg";